/**
 * Brands whose display name is not just their code capitalized. The provider
 * sends `amex`, and "Amex" on one screen beside "American Express" on another
 * reads as two different cards on file.
 */
const BRAND_NAMES: Record<string, string> = {
  amex: 'American Express',
};

/**
 * How a saved card's brand is named, everywhere a card is shown.
 *
 * The label alone, never the layout: one screen writes "Visa •••• 4242" on a
 * single line, another splits the brand from the digits, and both read the
 * brand from here. Null on a card whose brand the provider did not send —
 * inventing one would name a card we cannot identify.
 */
export const cardBrandLabel = (brand: string | null | undefined): string | null => {
  if (!brand) return null;

  return BRAND_NAMES[brand.toLowerCase()] ?? brand.charAt(0).toUpperCase() + brand.slice(1);
};
